import { memo } from 'react';

const NoResources = () => (
  <svg
    width="271"
    height="227"
    viewBox="0 0 271 227"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M136.871 206.35C181.482 206.35 217.831 170.151 217.831 125.69C217.831 81.079 181.632 45.0298 136.871 45.0298C92.1096 44.8796 55.9102 80.9289 55.9102 125.54C55.9102 170.151 92.1096 206.35 136.871 206.35Z"
      fill="#EAEEF9"
    />
    <path
      d="M122.601 97.4512L120.498 91.5932C120.047 90.0911 118.545 89.1899 117.043 89.1899H80.0928C76.9385 89.1899 74.5352 91.5932 74.5352 94.7476V177.511V163.842H200.707V105.412C200.707 102.258 198.304 99.8545 195.15 99.8545H126.056C124.553 99.8545 123.202 98.9533 122.601 97.4512Z"
      fill="url(#paint0_linear_3119_346075)"
    />
    <g filter="url(#filter0_d_3119_346075)">
      <path
        d="M78.1412 49.6851L103.376 93.5449C104.127 95.0469 103.676 96.9997 102.174 97.7507L59.2154 121.784C57.7133 122.535 55.7607 122.084 55.0096 120.582L23.3163 63.8043C22.2649 62.3022 23.0159 60.3496 24.5179 59.5986L55.7607 42.1748L78.1412 49.6851Z"
        fill="white"
      />
    </g>
    <path
      d="M55.4596 54.3422L34.7313 65.908C34.2807 66.2084 33.5296 66.0583 33.3794 65.4574C33.079 65.0068 33.2276 64.2558 33.6783 64.1056L54.4066 52.69C54.8573 52.3896 55.6082 52.5397 55.7584 52.9903C56.0588 53.441 55.9102 54.192 55.4596 54.3422Z"
      fill="#D5DDEA"
    />
    <path
      d="M45.3969 66.5082L37.4361 70.8642C36.9854 71.1646 36.3846 71.0144 36.2344 70.5638C35.934 70.1132 36.0842 69.3622 36.5348 69.212L44.3455 64.856C44.7961 64.5556 45.5471 64.7058 45.6973 65.1564C46.148 65.4568 45.9977 66.2078 45.3969 66.5082Z"
      fill="#D5DDEA"
    />
    <path
      d="M55.7598 42.1748L62.6693 54.3414C63.7207 55.9936 65.9738 56.5945 67.626 55.6933L78.591 49.6851"
      fill="#D5DDEA"
    />
    <path
      d="M80.6941 76.4212C79.3423 73.7175 77.5399 70.5631 75.2868 68.3101C74.0851 67.1084 72.5831 66.3574 70.7806 66.3574C68.9782 66.3574 67.3259 66.9582 65.5234 67.8595C62.3691 69.2113 59.5152 70.5632 56.6613 72.3656C54.1078 73.8677 51.1037 75.52 49.151 77.9232C46.5976 81.378 47.9494 84.8327 49.7519 88.4376C51.1037 91.1413 52.9062 94.2955 55.1593 96.5486C56.9617 98.3511 59.365 98.952 61.7683 98.2009C64.9226 97.4499 70.7806 94.1454 73.4843 92.4932C75.8876 90.9911 78.7415 89.6392 80.544 87.3861C83.9987 83.9314 82.797 80.3265 80.6941 76.4212ZM59.6654 80.1763C59.2148 79.2751 59.5152 78.5241 60.7169 78.6743C63.8712 78.8245 66.8752 78.8245 69.8793 78.9747C71.081 78.9747 71.3814 79.5755 70.9308 80.6269C69.4287 83.1804 67.9267 85.8841 66.4246 88.5878C65.8238 89.489 65.0728 89.4891 64.6222 88.738C64.1715 88.2874 60.116 80.9273 59.6654 80.1763Z"
      fill="#D5DDEA"
    />
    <path
      d="M173.671 126.291L172.319 125.389C172.019 125.089 172.019 124.789 172.319 124.488C172.619 124.188 172.92 124.188 173.371 124.338L174.722 125.239C175.023 125.389 175.023 125.84 174.873 126.14C174.422 126.441 173.971 126.441 173.671 126.291Z"
      fill="#E3EAF2"
    />
    <path
      d="M170.068 123.435L162.407 117.427C162.107 117.277 162.107 116.826 162.257 116.526C162.407 116.225 162.858 116.225 163.308 116.375L170.969 122.384C171.269 122.534 171.269 122.985 171.119 123.285C170.819 123.585 170.368 123.736 170.068 123.435Z"
      fill="#E3EAF2"
    />
    <g filter="url(#filter1_d_3119_346075)">
      <path
        d="M248.021 84.8325L219.332 121.933C218.43 123.285 216.628 123.435 215.276 122.384L179.527 94.2954C178.175 93.3941 178.025 91.5917 179.077 90.2399L216.328 42.9253C217.229 41.5734 219.031 41.4231 220.383 42.4746L246.369 62.9025L248.021 84.8325Z"
        fill="white"
      />
    </g>
    <path
      d="M235.857 66.9581L218.583 53.4397C218.283 53.1393 218.133 52.6886 218.433 52.0878C218.734 51.7874 219.184 51.6372 219.785 51.9376L237.059 65.4561C237.359 65.7565 237.509 66.2071 237.209 66.8079C236.758 67.2585 236.308 67.2586 235.857 66.9581Z"
      fill="#D5DDEA"
    />
    <path
      d="M222.038 62.7528L215.58 57.4956C215.279 57.1952 215.129 56.7446 215.429 56.1438C215.73 55.6932 216.18 55.6931 216.781 55.9935L223.24 61.2507C223.54 61.5511 223.691 62.0018 223.39 62.6026C222.94 63.0532 222.339 63.0532 222.038 62.7528Z"
      fill="#D5DDEA"
    />
    <path
      d="M246.371 62.9043L238.41 72.9681C237.208 74.4701 237.659 76.5729 239.011 77.6244L248.173 84.8342"
      fill="#D5DDEA"
    />
    <path
      d="M236.907 87.0865L227.895 80.1771L218.582 72.817L210.02 66.0578C209.119 65.3068 207.617 65.4569 206.866 66.5084L194.549 82.1297C193.798 83.031 193.948 84.533 194.85 85.284L221.887 106.613C222.788 107.364 224.29 107.214 225.041 106.163L237.358 90.5412C238.109 89.1894 237.959 87.9877 236.907 87.0865ZM208.368 86.9363L211.072 83.3314L219.333 89.7902L216.629 93.3951L208.368 86.9363ZM215.878 94.4466L213.325 97.7511L205.064 91.2922L207.617 87.9878L215.878 94.4466ZM222.938 85.284L220.234 88.889L211.973 82.4302L214.677 78.8252L222.938 85.284ZM215.428 77.7738L218.432 74.1689L226.693 80.6277L223.989 84.2327L215.428 77.7738ZM230.448 96.8498L221.286 89.64L223.989 86.035L233.152 93.245L230.448 96.8498ZM210.922 81.5289L202.059 74.6195L204.763 71.0145L213.625 77.924L210.922 81.5289ZM201.158 75.6709L210.02 82.5803L207.317 86.1853L198.455 79.2758L201.158 75.6709ZM220.535 90.6915L229.697 97.9013L226.993 101.506L217.831 94.2963L220.535 90.6915ZM236.306 89.4898L234.053 92.3437L224.891 85.1339L227.594 81.5289L236.006 88.138C236.607 88.4384 236.607 89.0392 236.306 89.4898ZM209.119 66.8088L217.23 73.2676L214.526 76.8726L205.664 69.9632L207.917 67.1092C208.218 66.6586 208.819 66.6586 209.119 66.8088ZM195.601 82.7306L197.553 80.3273L206.415 87.2368L203.862 90.5412L195.601 84.0824C195.3 83.782 195.3 83.031 195.601 82.7306ZM222.788 105.111L214.376 98.5021L216.93 95.1976L226.092 102.407L223.989 104.961C223.689 105.562 223.088 105.562 222.788 105.111Z"
      fill="#D5DDEA"
    />
    <path
      d="M163.006 120.582L154.445 119.681C153.994 119.681 153.694 119.23 153.844 118.78C153.844 118.329 154.294 118.029 154.895 118.179L163.457 119.08C163.907 119.08 164.208 119.531 164.058 119.981C163.907 120.432 163.457 120.882 163.006 120.582Z"
      fill="url(#paint1_linear_3119_346075)"
    />
    <path
      d="M203.263 128.694L193.95 170.301C193.349 172.704 190.495 174.657 186.89 174.657H85.8024C82.3477 174.657 79.3435 172.854 78.7427 170.301L71.0822 136.204C70.4814 133.651 73.3353 131.248 76.9402 131.248H134.018C135.821 131.248 137.172 130.346 137.773 129.295L139.426 125.69C140.026 124.488 141.528 123.737 143.181 123.737H197.555C201.01 123.737 203.713 126.141 203.263 128.694Z"
      fill="white"
    />
    <g filter="url(#filter2_d_3119_346075)">
      <path
        d="M210.621 123.135L200.257 186.973C199.656 190.728 196.352 193.582 192.447 193.582H79.7928C75.8875 193.582 72.5829 190.878 71.9821 186.973L63.4204 134.551C62.8196 130.646 65.8237 126.891 69.8792 126.891H133.416C135.369 126.891 137.021 125.539 137.622 123.736L139.424 118.179C140.025 116.376 141.677 115.024 143.63 115.024H204.163C208.068 115.475 211.222 119.08 210.621 123.135Z"
        fill="url(#paint2_linear_3119_346075)"
      />
    </g>
    <g filter="url(#filter3_d_3119_346075)">
      <path
        d="M176.376 39.6217L171.569 91.7429C171.419 93.5454 169.767 94.8972 167.965 94.5967L117.195 89.3396C115.393 89.1894 114.041 87.5372 114.191 85.7347L121.101 18.8934C121.251 17.0909 122.903 15.7391 124.705 16.0395L161.506 19.7946L176.376 39.6217Z"
        fill="white"
      />
    </g>
    <path
      d="M161.655 19.9463L160.153 34.2158C160.003 36.1684 161.505 38.1211 163.608 38.2713L176.525 39.6232"
      fill="#D5DDEA"
    />
    <path
      d="M166.462 77.6229L124.855 72.9666C123.804 72.8164 123.053 72.0653 123.203 71.0138L126.357 44.4276C126.507 43.5264 127.409 42.6251 128.31 42.7753L169.917 47.2814C170.968 47.4316 171.719 48.1827 171.569 49.2341L168.415 75.8204C168.264 76.8719 167.363 77.6229 166.462 77.6229Z"
      fill="#ECF0F8"
    />
    <path
      d="M147.684 71.1653L128.459 68.9123L139.272 59.1489L147.684 71.1653Z"
      fill="#D5DDEA"
    />
    <path
      d="M163.608 72.967L135.82 69.6624L151.592 55.6934L163.608 72.967Z"
      fill="white"
    />
    <path
      d="M137.771 54.9424C139.874 54.9424 141.526 53.2901 141.526 51.1873C141.526 49.0844 139.874 47.4321 137.771 47.4321C135.668 47.4321 134.016 49.0844 134.016 51.1873C134.016 53.2901 135.668 54.9424 137.771 54.9424Z"
      fill="#D5DDEA"
    />
    <path
      d="M153.844 28.6569L128.61 25.803C128.309 25.803 128.009 25.5025 128.159 25.2021V24.9018C128.159 24.6014 128.46 24.3009 128.76 24.4511L153.994 27.305C154.295 27.305 154.595 27.6055 154.445 27.9059V28.2062C154.595 28.5066 154.295 28.8071 153.844 28.6569Z"
      fill="#D5DDEA"
    />
    <path
      d="M153.693 33.4625L128.159 30.6086C127.858 30.6086 127.558 30.3082 127.708 30.0078V29.7073C127.708 29.4069 128.008 29.1065 128.309 29.2568L153.844 32.1107C154.144 32.1107 154.444 32.411 154.294 32.7115V33.0119C154.444 33.1621 153.994 33.4625 153.693 33.4625Z"
      fill="#D5DDEA"
    />
    <path
      d="M154.595 82.5811L122.902 78.9762C122.451 78.9762 122.151 78.5255 122.301 78.0749C122.301 77.6243 122.751 77.3239 123.352 77.4741L154.895 81.079C155.346 81.079 155.646 81.5297 155.496 81.9803C155.346 82.4309 155.046 82.7313 154.595 82.5811Z"
      fill="#D5DDEA"
    />
    <path
      d="M149.939 37.97L127.708 35.4166C127.258 35.4166 126.957 34.9659 127.107 34.5153C127.107 34.0647 127.558 33.7644 128.159 33.9146L150.389 36.468C150.84 36.468 151.14 36.9187 150.99 37.3693C150.84 37.6697 150.539 37.97 149.939 37.97Z"
      fill="#D5DDEA"
    />
    <path
      d="M166.312 88.7393L122.152 83.4822C121.701 83.4822 121.401 83.0315 121.551 82.5809C121.551 82.1303 122.001 81.8299 122.602 81.9801L166.763 87.087C167.213 87.087 167.514 87.5377 167.363 87.9883C167.213 88.4389 166.763 88.7393 166.312 88.7393Z"
      fill="#D5DDEA"
    />
    <path
      d="M120.499 9.13021C119.898 9.43062 119.147 9.13017 118.847 8.52935L116.143 1.77012C115.843 1.1693 116.143 0.418264 116.744 0.117854C117.345 -0.182556 118.096 0.117845 118.396 0.718665L121.1 7.4779C121.551 8.37913 121.25 8.98 120.499 9.13021Z"
      fill="#D5DDEA"
    />
    <path
      d="M115.541 15.7388C115.241 16.0392 114.94 16.1894 114.339 16.0392L107.28 14.6873C106.679 14.5371 106.078 13.9363 106.228 13.1853C106.379 12.5844 106.979 11.9837 107.73 12.2841L114.79 13.636C115.391 13.7862 115.992 14.387 115.841 15.138C115.691 15.2882 115.691 15.5886 115.541 15.7388Z"
      fill="#D5DDEA"
    />
    <path
      d="M129.812 8.37911C129.662 8.37911 129.512 8.22885 129.211 8.22885C128.761 7.77823 128.611 7.02723 129.061 6.42641L133.417 0.718588C133.868 0.267972 134.619 0.117804 135.22 0.568419C135.67 1.01903 135.82 1.77003 135.37 2.37085L131.014 8.07868C130.563 8.22888 130.113 8.37911 129.812 8.37911Z"
      fill="#D5DDEA"
    />
    <path
      d="M167.214 183.517C166.613 186.071 165.712 188.775 164.66 191.028C161.807 196.585 157.3 200.941 151.743 203.795C146.035 206.649 139.276 207.851 132.517 206.349C116.595 203.044 106.381 187.423 109.685 171.501C112.99 155.579 128.461 145.215 144.383 148.67C150.091 149.871 155.047 152.725 159.253 156.631C166.313 163.69 169.317 173.904 167.214 183.517Z"
      fill="url(#paint3_linear_3119_346075)"
    />
    <path
      d="M147.837 174.958H141.078V168.199C141.078 166.847 140.026 165.645 138.524 165.645C137.173 165.645 135.971 166.696 135.971 168.199V174.958H129.212C127.86 174.958 126.658 176.009 126.658 177.511C126.658 179.013 127.71 180.065 129.212 180.065H135.971V186.824C135.971 188.176 137.022 189.378 138.524 189.378C139.876 189.378 141.078 188.326 141.078 186.824V180.065H147.837C149.189 180.065 150.391 179.013 150.391 177.511C150.391 176.009 149.189 174.958 147.837 174.958Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_3119_346075"
        x="0.826172"
        y="31.1748"
        width="124.906"
        height="123.965"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346075"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346075"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3119_346075"
        x="156.387"
        y="30.7846"
        width="113.635"
        height="125.289"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346075"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346075"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_3119_346075"
        x="41.3438"
        y="104.024"
        width="191.352"
        height="122.557"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346075"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346075"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_3119_346075"
        x="92.1797"
        y="4.99756"
        width="106.197"
        height="122.641"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3119_346075"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3119_346075"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3119_346075"
        x1="137.632"
        y1="92.2586"
        x2="137.632"
        y2="141.832"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3119_346075"
        x1="153.647"
        y1="118.752"
        x2="163.898"
        y2="119.935"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#83A6FF" />
        <stop offset="1" stopColor="#5A78FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3119_346075"
        x1="136.971"
        y1="113.208"
        x2="136.971"
        y2="194.429"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3119_346075"
        x1="138.473"
        y1="150.054"
        x2="138.473"
        y2="183.167"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);

const NoResourcesIcon = memo(NoResources);
export default NoResourcesIcon;
